import { render, staticRenderFns } from "./object-item.vue?vue&type=template&id=0c941fde"
import script from "./object-item.vue?vue&type=script&lang=js"
export * from "./object-item.vue?vue&type=script&lang=js"
import style0 from "./object-item.vue?vue&type=style&index=0&id=0c941fde&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports